/**
 * Support workflow & policies — automations.
 *
 * Each stage of the Workflow can have automations: "when ‹trigger› → do
 * ‹steps›". A trigger starts a run for one ticket; the run does its steps in
 * order, and a wait parks it until its time comes (or, for "wait for the
 * customer", until they reply). Leaving the stage cancels its runs still
 * waiting, except a run that moved the ticket on itself.
 */
export const SUPPORT_AUTOMATION_TRIGGERS = [
    'on_enter',
    'on_exit',
    'time_in_stage',
    'customer_reply',
    'due_internal',
    'due_external',
    'due_response',
    'fields_complete',
];
export const SUPPORT_AUTOMATION_TRIGGER_LABELS = {
    on_enter: 'A ticket enters this stage',
    on_exit: 'A ticket leaves this stage',
    time_in_stage: 'A ticket has been in this stage for…',
    customer_reply: 'The customer replies while the ticket is in this stage',
    due_internal: 'The internal (team) due time passes',
    due_external: 'The external (customer) due time passes',
    due_response: 'The first reply is late (no one on the team has answered)',
    fields_complete: 'All the required fields are complete (files included)',
};
/** Triggers that need a time: required for time_in_stage, "after" for the due ones. */
export function triggerUsesMinutes(trigger) {
    return (trigger === 'time_in_stage' ||
        trigger === 'due_internal' ||
        trigger === 'due_external' ||
        trigger === 'due_response');
}
export const SUPPORT_AUTOMATION_ACTION_LABELS = {
    send_message: 'Send a message to the customer',
    send_email: 'Send an email',
    wait: 'Wait',
    wait_reply: 'Wait for the customer to reply',
    move_stage: 'Move to a stage',
    assign: 'Assign to',
    set_priority: 'Set the priority',
    add_note: 'Add an internal note',
    notify_team: 'Email team members',
};
/** The words a message, email or note can carry, filled from the ticket. */
export const SUPPORT_AUTOMATION_PLACEHOLDERS = [
    '{{ticket.number}}',
    '{{ticket.subject}}',
    '{{customer.name}}',
    '{{stage}}',
    '{{priority}}',
    '{{assignee}}',
];
//# sourceMappingURL=support-automation.js.map